var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-423bf9ae": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 1 90 90",
    className: "iconLeft",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(25)",
    id: "7c0d8fab-e641-4bab-a435-8d94965a9df6",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(40, 139, 88)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(21, 34, 241)",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07124146985131,0,0,1.07124146985131,-8.570770200714655,-7.568178910851508)",
    stroke: "none",
    fill: "url(#7c0d8fab-e641-4bab-a435-8d94965a9df6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.135 49.287a2.256 2.256 0 0 0-1.426-1.423L26.847 39.91a2.256 2.256 0 0 0-2.305.542l-7.954 7.956a2.252 2.252 0 0 0 .879 3.725l22.798 7.596 7.598 22.803A2.256 2.256 0 0 0 50 84.071c.588 0 1.164-.234 1.589-.659l7.959-7.954a2.258 2.258 0 0 0 .542-2.305l-7.955-23.866zm-1.153 28.367L44.18 57.239a2.258 2.258 0 0 0-1.426-1.421l-20.41-6.802 4.397-4.399 21.477 7.16 7.163 21.479-4.399 4.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.043 33.377a2.26 2.26 0 0 0-1.421-1.424l-23.867-7.954a2.268 2.268 0 0 0-2.3.545l-7.959 7.954a2.248 2.248 0 0 0 .879 3.725l22.803 7.598 7.598 22.798a2.245 2.245 0 0 0 2.134 1.538c.591 0 1.165-.229 1.592-.659l7.954-7.954a2.258 2.258 0 0 0 .542-2.305l-7.955-23.862zm-1.152 28.364l-6.802-20.41a2.262 2.262 0 0 0-1.421-1.421l-20.415-6.805 4.399-4.396 21.479 7.158 7.158 21.477-4.398 4.397z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.956 17.469a2.254 2.254 0 0 0-1.426-1.426L58.668 8.089a2.267 2.267 0 0 0-2.305.544l-7.954 7.957a2.24 2.24 0 0 0-.601 2.104 2.254 2.254 0 0 0 1.479 1.621l22.798 7.598 7.598 22.798a2.258 2.258 0 0 0 2.137 1.538c.588 0 1.164-.232 1.589-.659l7.954-7.954a2.253 2.253 0 0 0 .547-2.305l-7.954-23.862zm-1.152 28.364l-6.807-20.41a2.26 2.26 0 0 0-1.421-1.424l-20.412-6.804 4.399-4.397 21.477 7.161 7.158 21.477-4.394 4.397zM35.68 64.319a2.252 2.252 0 0 0-3.184 0L8.634 88.182a2.252 2.252 0 0 0 3.184 3.184L35.68 67.498a2.246 2.246 0 0 0 0-3.179zM15.792 71.478l7.954-7.954c.879-.879.879-2.305 0-3.184s-2.3-.879-3.179 0l-7.954 7.954a2.252 2.252 0 0 0 1.59 3.843c.576 0 1.15-.22 1.589-.659zM36.476 76.248l-7.954 7.959a2.246 2.246 0 0 0 0 3.179c.439.439 1.014.659 1.59.659s1.149-.22 1.589-.659l7.959-7.954a2.252 2.252 0 0 0-3.184-3.184z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.236a93c7cb573f886c2f78427c955933.svg";
export { ForwardRef as ReactComponent };